import AnchorScrollPresenter from "../components/anchor-scroll/presenter/anchor-scroll.js";

const anchorScrollComponent = new AnchorScrollPresenter();
anchorScrollComponent.init();
